/*
 * Copyright © 2024. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { getStatusBoxConfigEmploymentContract } from "@/src/services/employmentContract/statusBoxSteps";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import React from "react";
import { getCaseLink } from "@/src/services/productService";
import { STATUS_CREATED } from "@/src/services/litigationCase/leadStatus";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

const getButton = (employmentContractCase: AbstractCase) => {
  return (
    <Button component={Link} to={getCaseLink(employmentContractCase) + "/antrag"} variant="contained" color="primary" fullWidth>
      Weiteres Vorgehen festlegen
    </Button>
  );
};

export const getStatusBoxConfigEmploymentContractAdvocardFlexService = (employmentContractCase: AbstractCase) => {
  let boxConfig = getStatusBoxConfigEmploymentContract(employmentContractCase);

  if (employmentContractCase.caseCategory === "advisory" && employmentContractCase.leadStatus === STATUS_CREATED) {
    return {
      ...boxConfig,
      header: "Jetzt Ihren Fall schildern",
      text: "Beschreiben Sie hier kurz in Anliegen. Danach können Sie direkt einen Termin für Ihr Erstgespräch buchen.",
      ctaButton: getButton(employmentContractCase),
    };
  }

  return boxConfig;
};
